import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import ApiService from 'services/ApiService/ApiService';
import { convertTokensToDollars } from 'utils/helpers';
import parseCatch from 'utils/parseCatch';

import { STUDIO_REVENUE_INSIGHTS } from './Api';


const FETCHING_EARNINGS = 'cam4/revenueinfo/FETCHING_EARNINGS';
const UPDATE_MONTHLY_REVENUE = 'cam4/revenueinfo/UPDATE_MONTHLY_REVENUE';
const UPDATE_YESTERDAY_REVENUE = 'cam4/revenueinfo/UPDATE_YESTERDAY_REVENUE';

const initialState = Immutable.fromJS({
  yesterdayRevenue: 0,
  monthlyRevenue: 0,
  isFetchingEarnings: false,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_MONTHLY_REVENUE:
      return state.set('monthlyRevenue', action.monthlyRevenue);

    case UPDATE_YESTERDAY_REVENUE:
      return state.set('yesterdayRevenue', action.yesterdayRevenue);

    case FETCHING_EARNINGS:
      return state.set('isFetchingEarnings', action.isFetchingEarnings);

    default:
      return state;
  }
}

export const NAME = 'revenueinfo';

const revenueinfo = (state) => state[NAME];
const yesterdayRevenue = (state) => state[NAME].get('yesterdayRevenue');
const monthlyRevenue = (state) => state[NAME].get('monthlyRevenue');
const isFetchingEarnings = (state) => state[NAME].get('isFetchingEarnings');

export const selector = createStructuredSelector({
  revenueinfo,
  yesterdayRevenue,
  monthlyRevenue,
  isFetchingEarnings,
});

function updateMonthlyRevenue(monthlyRevenue) {
  return {
    type: UPDATE_MONTHLY_REVENUE,
    monthlyRevenue,
  };
}

function updateYesterdayRevenue(yesterdayRevenue) {
  return {
    type: UPDATE_YESTERDAY_REVENUE,
    yesterdayRevenue,
  };
}

function setIsFetchingEarnings(isFetchingEarnings) {
  return {
    type: FETCHING_EARNINGS,
    isFetchingEarnings,
  };
}

function formatDate(date) {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) {
    month = `0${month}`;
  }
  if (day.length < 2) {
    day = `0${day}`;
  }

  return [year, month, day].join('-');
}

function parseResults(res) {
  let monthlyRevenue = 0;
  let yesterdayRevenue = 0;
  const date = new Date();
  const yesterday = formatDate(date.setDate(date.getDate() - 1));

  res.data?.forEach?.((n) => {
    monthlyRevenue += convertTokensToDollars(n.amount);
    if (yesterday === n.date) {
      yesterdayRevenue += convertTokensToDollars(n.amount);
    }
  });

  return (dispatch) => {
    dispatch(updateMonthlyRevenue(monthlyRevenue));
    dispatch(updateYesterdayRevenue(yesterdayRevenue));
  };
}

function getPerformerEarnings(username) {
  const today = new Date();
  const startDate = formatDate(today.setDate(1));
  const endDate = formatDate(new Date());
  const parsedUrl = ApiService.substitute(STUDIO_REVENUE_INSIGHTS, { username });

  return (dispatch) => {
    dispatch(setIsFetchingEarnings(true));
    const params = {
      from: startDate,
      to: endDate,
    };

    ApiService.get(parsedUrl, { params })
      .then((res) => {
        dispatch(parseResults(res));
        dispatch(setIsFetchingEarnings(false));
      })
      .catch((error) => {
        dispatch(setIsFetchingEarnings(false));
        parseCatch(error);
      });
  };
}

export const actionCreators = { getPerformerEarnings };
